// @flow
import React from 'react';
import { defaultIconProps, type IconProps, IconSvgWrapper } from './base';

const DownloadIcon = (props: IconProps) => (
  <IconSvgWrapper {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.708 13.473L15.672 10.509C15.948 10.233 16.392 10.233 16.656 10.497C16.932 10.773 16.932 11.217 16.656 11.493L12.504 15.657C12.228 15.933 11.796 15.933 11.52 15.657L7.35599 11.493C7.07999 11.217 7.07999 10.773 7.35599 10.497C7.63199 10.221 8.07599 10.221 8.35199 10.497L11.316 13.461V3.46504C11.316 3.08104 11.628 2.76904 12.012 2.76904C12.396 2.76904 12.708 3.08104 12.708 3.46504V13.473ZM19.056 15.024C19.056 14.64 19.368 14.328 19.752 14.328C20.136 14.328 20.448 14.64 20.472 15.024V20.532C20.472 20.916 20.16 21.228 19.776 21.228H4.26C3.876 21.228 3.564 20.916 3.564 20.532V15.024C3.564 14.64 3.876 14.328 4.26 14.328C4.644 14.328 4.95599 14.64 4.95599 15.024V19.608C4.95599 19.728 5.05199 19.824 5.17199 19.824H18.84C18.96 19.824 19.056 19.728 19.056 19.608V15.024Z"
    />
  </IconSvgWrapper>
);

DownloadIcon.defaultProps = defaultIconProps;

export default DownloadIcon;
